import Cookies from 'js-cookie';
import { Modal } from 'flowbite';
import { trapFocus } from './focus-trap';

const menu = document.getElementById('main-nav');
let hamMenuOpen = false;
const cookie_community_alert = 'STYXKEY_win_alert_community';
const cookie_metro_alert = 'STYXKEY_win_alert_metro';
const cookie_neighborhood_alert = 'STYXKEY_win_alert_neighborhood';
const cookie_community_popup = 'STYXKEY_win_popup_community';
const cookie_metro_popup = 'STYXKEY_win_popup_metro';
const cookie_neighborhood_popup = 'STYXKEY_win_popup_neighborhood';
const cookie_location_popup = 'STYXKEY_win_popup_location';
const cookie_fee_calculator_popup = 'STYXKEY_win_fee_calculator_popup';
const modalToggle = document.getElementById('modal-property-promo-popup');
const modal = modalToggle ? new Modal(modalToggle) : null;
const modalFeeCalculatorToggle = document.getElementById('modal-property-fee-calculator-popup');
const modalFeeCalculator = modalFeeCalculatorToggle ? new Modal(modalFeeCalculatorToggle) : null;

const urlParams = new URLSearchParams(window.location.search);

const MainNav = {
    hamburger() {
        $('#hamburger').on('click', function () {
            if ($(this).find(".tham").hasClass('tham-active')) {
                MainNav.closeMobileNav();
            } else {
                MainNav.openMobileNav();
                $(".main-nav nav ul.menu li:first-child a").css("outline-style", "none");
            }
            return false;
        });
        // keyboard accessibility to open items
        const openNav = document.getElementById('hamburger');
        openNav.addEventListener('keydown', function (e) {
            if (e.code === 'Space' || e.code === 'Enter') {
                e.preventDefault();
                // add css of the outline to the classname
                if ($(this).find(".tham").hasClass('tham-active')) {
                    MainNav.closeMobileNav();
                } else {
                    MainNav.openMobileNav();
                    $(".main-nav nav ul.menu li:first-child a").css("outline-style", "solid");
                }

            }
        }); //keyboard accessibility to open items

    },
    openMobileNav() {
        $('.tham').addClass('tham-active');
        $('.mobile-nav').addClass('open');
        $('body').addClass('menu-open');
        trapFocus(menu, {
            onEnd: () => document.getElementById('hamburger').focus(),
        });
        hamMenuOpen = true;

        $('html, body').animate(
            {
                scrollTop: $('header').offset().top - 1,
            },
            100
        );
    },
    closeMobileNav() {
        $('.tham').removeClass('tham-active');
        $('.mobile-nav').removeClass('open');
        $('body').removeClass('menu-open');
        // document.getElementById('hamburger').focus();
        hamMenuOpen = false;

        if ($('#mobile-quick-search-wrapper').hasClass('open')) {
            $('#mobile-quick-search-wrapper').removeClass('open');
            $('body').removeClass('overflow-hidden');
            $('.header').removeClass('fixed-header');
        }
    },
    searchToggle() {
        $('.header-search__toggle').on('click', function () {
            if ($('.header-search__mobile').attr('open')) {
                $('.header-search__mobile').attr('open', false);
            } else {
                $('.header-search__mobile').attr('open', true);
                $('.header-search__mobile .autocomplete-input')
                    .trigger('select')
                    .trigger('focus');
            }
            return false;
        });
    },
    // define a function that sets min-height of ham menu to window.innerHeight:
    setHeight() {
        let headerHeight = $('header').outerHeight();
        document.getElementById('main-nav').style.minHeight =
            window.innerHeight - headerHeight + 'px';
    },
    checkHamMenuOpen() {
        if (hamMenuOpen) {
            if ($(window).width() >= 1024) {
                $('body').removeClass('menu-open');
            } else {
                $('body').addClass('menu-open');
            }
        }
    },

    // Alert close
    alertClose() {
        $('.wc-alert .js-alert-close').click(function (e) {
            e.preventDefault();
            var source = $(this).attr('data-source');
            var alertid = $(this).attr('data-alertid');
            if (source == 'community')
                Cookies.set(cookie_community_alert + '_' + alertid, 1);
            else if (source == 'metro')
                Cookies.set(cookie_metro_alert + '_' + alertid, 1);
            else if (source == 'neighborhood')
                Cookies.set(cookie_neighborhood_alert + '_' + alertid, 1);
            $(this).parents('.wc-alert').addClass('alert__hidden');
        });
    },

    promoPopup() {
        setTimeout(() => {
            modal.show();
            modalToggle.focus();
            trapFocus(modalToggle);
        }, 2000);
    },

    feeCalculatorPopup() {
        setTimeout(() => {
            modalFeeCalculator.show();
            modalFeeCalculatorToggle.focus();
            trapFocus(modalFeeCalculatorToggle);
        }, 2000);
    },

    init() {
        MainNav.hamburger();
        MainNav.searchToggle();
        MainNav.alertClose();
        
        if (modal && !(urlParams.has('scheduleTourModal') || urlParams.has('contactModal'))) {
            var popupid = $(modalToggle).attr("data-popupid");
            var source = $(modalToggle).attr("data-source");
            if(source == "community")
                var cookieValue = Cookies.get(cookie_community_popup+"_"+popupid);
            else if(source == "metro")
                var cookieValue = Cookies.get(cookie_metro_popup+"_"+popupid);
            else if(source == "neighborhood")
                var cookieValue = Cookies.get(cookie_neighborhood_popup+"_"+popupid);
            else if(source == "location")
                var cookieValue = Cookies.get(cookie_location_popup+"_"+popupid);
            if(cookieValue == 1){
                modal.hide();
            }else{
                MainNav.promoPopup();
            }
        }
        if(modalFeeCalculatorToggle) {
            var post_id = $(modalFeeCalculatorToggle).attr("data-postid");
            var cookieValue = Cookies.get(cookie_fee_calculator_popup+"_"+post_id);            
            /*if(cookieValue == 1){
                modalFeeCalculator.hide();
            }else{*/
                MainNav.feeCalculatorPopup();
            //}
        }

        $('.main-nav__close').on('click', function () {
            MainNav.closeMobileNav();
            return false;
        });

        $('.property-promo-popup-content .modal-button').on(
            'click',
            function () {
                modal.hide();
            }
        );

        // Promo popup modal close button click
        $(document).on(
            'click',
            '#modal-property-promo-popup .promo-popup-modal-close',
            function (event) {
                window.setTimeout(() => {
                    var source = $(this).attr("data-source");
                    var popupid = $(this).attr("data-popupid");
                    if(source == "community")
                        Cookies.set(cookie_community_popup+"_"+popupid, 1);
                    else if(source == "metro")
                        Cookies.set(cookie_metro_popup+"_"+popupid, 1);
                    else if(source == "neighborhood")
                        Cookies.set(cookie_neighborhood_popup+"_"+popupid, 1);
                    else if(source == "location")
                        Cookies.set(cookie_location_popup+"_"+popupid, 1);
                    modal.hide();
                }, 100);
            }
        );

        //Fee calculator close modal
        $(document).on(
            'click',
            '#modal-property-fee-calculator-popup .promo-popup-modal-close, #property-fee-calculator-popup-btn',
            function (event) {
                window.setTimeout(() => {
                    var postid = $(this).attr("data-postid");
                    Cookies.set(cookie_fee_calculator_popup + '_' + postid, 1);
                    modalFeeCalculator.hide();
                }, 100);
            }
        );


        // define mobile screen size:

        let deviceWidth = window.matchMedia('(max-width: 1024px)');

        if (deviceWidth.matches) {
            // set an event listener that detects when innerHeight changes:
            window.addEventListener('resize', MainNav.setHeight);
            // call the function once to set initial height:
            MainNav.setHeight();
        }

        window.addEventListener('resize', MainNav.checkHamMenuOpen);
    },
};

export default MainNav;
